import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { MasterApiService } from 'src/app/services/master-api.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.sass'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
    
  @Input() userName:string = '';
  @Input() oldPassword:string = '';

  form?: FormGroup;
  
  constructor(private fb: FormBuilder, private api: MasterApiService, private alertService: AlertService, private tr:TranslateService) { }

  ngOnInit(): void {
    this.form = this.initFormGroup();
  }

  initFormGroup(): FormGroup {
    return this.fb.group({
      password: [''],
      confirmPassword: [''],
    }, {
      validators: this.checkPasswords
    });
  }

  async resetPassword() : Promise<void> {
    try {
      await firstValueFrom(this.api.resetPassword(this.userName, this.oldPassword, this.form?.value['password']));
      location.reload();
    } catch (error) {
      this.alertService.error(this.tr.instant('common.errorResetingPassword'));
    }
  }

  private checkPasswords(group: AbstractControl): ValidationErrors | null {
    const pass = group.get('password')?.value;
    const confirmPass = group.get('confirmPassword')?.value;

    return pass === confirmPass ? null : { notSame: true };
  }

}
